import { MezziService } from './../services/mezzi.service';
import { IMezzo } from './../interfaces/IMezzo';
import { Component, OnInit, ViewChild } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig, MenuItem } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { AlertUtil } from '../utils/alert-util';
import { DocumentiService } from '../services/documenti.service';
import { OverlayPanel } from 'primeng/overlaypanel';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Loading } from '../utils/loading';
import { RequestBuilder } from '../classes/request-builder';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-mezzo-modal',
  templateUrl: './mezzo-modal.component.html',
  styleUrls: ['./mezzo-modal.component.css']
})
export class MezzoModalComponent implements OnInit {

  @ViewChild('op') op: OverlayPanel

  mezzo: IMezzo
  fromFiliera: boolean

  itemsAllegato: MenuItem[];

  usernamePattern = "^[a-zA-Z0-9-_.!-]*$";
  maxPattern = "^[0-9]{1,11}$"

  fileName: string  // name of file already uploaded
  uploadedFile: any //for upload file
  attachmentUrl: string = ""                  // url dell'allegato

  mezzoForm: FormGroup
  isUpdate: boolean = false

  constructor(private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private translate: TranslateService,
    private alertUtil: AlertUtil,
    private documentiService: DocumentiService,
    private formBuilder: FormBuilder,
    private mezzoService: MezziService) {
    this.mezzo = this.config.data.mezzo
    this.fromFiliera = this.config.data.fromFiliera
    this.isUpdate = this.mezzo ? true : false
    //build form group
    this.serForm();
  }

  ngOnInit() {
  }

  private serForm() {
    this.mezzoForm = this.formBuilder.group({
      'definizione': [this.isUpdate ? this.mezzo.Definizione : '', Validators.required],
      'tipo': [this.isUpdate ? this.mezzo.Tipo : '', Validators.required],
      'targaMatricola': [{value: this.isUpdate ? this.mezzo.Targa : '', disabled: this.isUpdate}, Validators.required],
      'marca': [this.isUpdate ? this.mezzo.Marca : '', Validators.required],
      'modello': [this.isUpdate ? this.mezzo.Modello : '', Validators.required]
    });
  }

  // convenience getter for easy access to form fields
  get form() { return this.mezzoForm.controls; }

  onSubmit() {
    if (this.mezzoForm.valid) {
      //retrieve values from form
      let definizione = this.mezzoForm.controls['definizione'].value
      let targa = this.mezzoForm.controls['targaMatricola'].value
      let marca = this.mezzoForm.controls['marca'].value
      let modello = this.mezzoForm.controls['modello'].value
      let tipo = this.mezzoForm.controls['tipo'].value
      let noleggio = false

      let mezzoObj: IMezzo = {
        Definizione: definizione,
        Targa: targa,
        Marca: marca,
        Modello: modello,
        Tipo: tipo,
        Noleggio: noleggio
      }
      this.callSaveMezzo(mezzoObj)

    }
  }

  /**
   * callback fired when save button is pressed
   */
  onSaveMezzo() {


  }

  /**
  * callback fired when file is uploaded
  * @param event file
  * @param upload 
  */
  uploadClick(event: any, upload: any) {
    this.uploadedFile = null
    upload.clear()
    if (event.files) {
      this.uploadedFile = event.files[0];
      this.fileName = this.uploadedFile.name
    }
  }

  /**
   * 
   * @param menu 
   * @param event
   */
  openMenu(menu, event) {
    this.optionsAllegato(event)
    menu.toggle(event)
  }

  /**
   * set options allegato
   * @param event 
   */
  private optionsAllegato(event: any) {
    this.translate.get(["LBL_ALLEGATO_APRI", "LBL_ALLEGATO_CANCELLA",]).subscribe(res => {
      this.itemsAllegato = [
        {
          label: res["LBL_ALLEGATO_APRI"], icon: 'pi pi-download', command: () => {
            this.openAllegato(event);
          }
        }
        // ,
        // {
        //   label: res["LBL_ALLEGATO_CANCELLA"], icon: 'pi pi-trash', command: () => {
        //     this.deleteAllegato(event);
        //   }
        // }
      ]
    })
  }

  /**
   * open allegato in other tab
   */
  openAllegato(event: any) {

  }

  /**
   * delete allegato service
   * @param event 
   */
  deleteAllegato(event: any) {

  }

  /**
   * determines whether save button is disabled
   */
  isDisabledButton(): boolean {
    let isDisabled: boolean = true

    if (this.uploadedFile || this.fileName) {
      isDisabled = false
    }

    return isDisabled
  }

  /**
   * create mezzo
   * @param mezzoObj mezzoObj
   */
  callSaveMezzo(mezzoObj: IMezzo) {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder(mezzoObj)
    this.mezzoService.save(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.alertUtil.showAlert("LBL_NEW_MEZZO_SUCCESS", null, null, null, () => {
            this.ref.close(mezzoObj)
          })
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }
}
